import formCreate from "./formCreate";
import formEdit from "./formEdit";
import formList from "./formList";
import { LibraryBooksRounded,PostAddRounded} from "@mui/icons-material";
const Form = {
  list: formList,
  edit: formEdit,
  create: formCreate,
  icon: LibraryBooksRounded,
  createIcon: PostAddRounded,
};
export default Form;